import React from 'react'

import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Paper } from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { UrlQueryParamTypes, addUrlProps } from 'react-url-query'

import api from 'common/api'
import HighSchoolTypeahead from 'components/HighSchoolTypeahead'
import { actions as visitSelectedSchoolsActions } from 'store/selected-schools'

import { shortTimeZone } from '../View/helper'
import './VisitHighSchoolFilter.scss'

export class VisitHighSchoolFilter extends React.Component {
  static propTypes = {
    hsid: PropTypes.string,
    onChangeHsid: PropTypes.func.isRequired,
    addSelectedSchool: PropTypes.func.isRequired,
    removeSelectedSchool: PropTypes.func.isRequired,
    selectedSchools: PropTypes.arrayOf(PropTypes.object).isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.hasUsedUrlParam = false
  }

  componentDidMount() {
    this.handleParams()
  }

  handleParams() {
    if (this.props.hsid) {
      api
        .get(`/api/highschools/${this.props.hsid}/locations`)
        .then((response) => {
          const hs = response[0].HighSchool
          this.onSelectHighSchool({
            City: hs.City,
            Id: hs.Id,
            Name: hs.SchoolName,
            State: hs.State,
          })
          this.props.onChangeHsid()
        })
        .catch(() => {})
    }
  }

  onSelectHighSchool(hs) {
    const duplicateIndex = this.props.selectedSchools.findIndex((selectedHS) => selectedHS.Id === hs.Id)
    if (duplicateIndex === -1) {
      this.props.addSelectedSchool(hs)
      this.updateSelectedSchoolsParam([...this.props.selectedSchools, hs])
    }
  }

  dimissSchoolByIndex(idx) {
    this.props.removeSelectedSchool(idx)
    this.updateSelectedSchoolsParam(this.props.selectedSchools.filter((_, i) => i !== idx))
  }

  updateSelectedSchoolsParam(schools) {
    const params = new URLSearchParams(this.props.location.search)
    if (schools.length > 0) {
      params.set(
        'selectedSchools',
        JSON.stringify(schools.map((hs) => ({ id: hs.Id, name: hs.Name, timeZone: hs.TimeZone }))),
      )
    } else {
      params.delete('selectedSchools')
    }
    this.props.history.replace({ search: params.toString() })
  }

  render() {
    const params = new URLSearchParams(this.props.location.search)
    const selectedSchoolsParam = params.get('selectedSchools')

    if (selectedSchoolsParam && !this.hasUsedUrlParam) {
      try {
        const schools = JSON.parse(selectedSchoolsParam).map(({ id, name, timeZone }) => ({
          Id: id,
          Name: name,
          TimeZone: timeZone,
        }))
        this.props.setSelectedSchools([])
        schools.forEach((school) => {
          this.props.addSelectedSchool(school)
        })
        this.hasUsedUrlParam = true
      } catch (e) {
        console.error('Failed to parse selectedSchools:', e)
      }
    }

    return (
      <div className="high-school-filter-comp">
        <div className="filter-header">View HS Visit Availability</div>
        <HighSchoolTypeahead onSelect={(hs) => this.onSelectHighSchool(hs)} />
        <List dense>
          {this.props.selectedSchools &&
            this.props.selectedSchools.map((hs, idx) => (
              <ListItem
                key={hs.Id}
                component={Paper}
                elevation={0}
                divider
              >
                <ListItemText primary={`${hs.Name} ${hs.TimeZone ? `(${shortTimeZone(hs.TimeZone)})` : ''}`} />
                <ListItemSecondaryAction>
                  <IconButton
                    size="small"
                    edge="end"
                    aria-label="dismiss school"
                    onClick={() => this.dimissSchoolByIndex(idx)}
                  >
                    <FontAwesomeIcon
                      size="xs"
                      icon={faTimes}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
      </div>
    )
  }
}

export const ConnectedVisitHighSchoolFilter = connect(
  (state) => ({
    selectedSchools: state.visitSelectedSchools,
  }),
  {
    addSelectedSchool: visitSelectedSchoolsActions.addSelectedSchool,
    removeSelectedSchool: visitSelectedSchoolsActions.removeSelectedSchool,
    setSelectedSchools: visitSelectedSchoolsActions.setSelectedSchools,
  },
)(withRouter(VisitHighSchoolFilter))

const urlPropsQueryConfig = {
  hsid: { type: UrlQueryParamTypes.string },
}

export default addUrlProps({ urlPropsQueryConfig, addUrlChangeHandlers: true })(ConnectedVisitHighSchoolFilter)
